import { gql } from "@apollo/client";
export default gql`
  mutation UserFeedback($input: FeedbackInput!) {
    userFeedback(input: $input) {
      message
    }
  }
`;
